import cisFertigationDataConfig from '@/api/config/cisFertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { IFormCisFertigation } from '@/types/cisFertigation'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function create(payload: IFormCisFertigation): Promise<void> {
  await cisFertigationDataConfig.create(payload)
}

function useAddCisFertigation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: IFormCisFertigation) => create(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.cisFertigation])
      toast.success(t('addFertigationSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else if (error?.statusCode === 404) {
        toast.error(error?.message)
      } else toast.error(t('addFertigationError'))
    },
  })
}

export default useAddCisFertigation
